import axiosInstance from './axiosInstance';

export type LiveSiteStatus = 'none' | 'pending' | 'deploying' | 'live' | 'failed';

export interface LiveSitePage {
  page_name: string;
  path: string;
  url: string;
}

export interface LiveSiteDeploy {
  id: string;
  status: 'building' | 'live' | 'unchanged' | 'skipped' | 'failed';
  trigger: 'design' | 'build';
  reasons: string[];
  request_count: number;
  page_count: number;
  error: string | null;
  started_at: string | null;
  finished_at: string | null;
}

/** A project's public live link; `url` stays null until its first finished page is published. */
export interface LiveSite {
  /** True once a real production deploy holds the same host (the link opens the built app). */
  app_live?: boolean;
  status: LiveSiteStatus;
  url: string | null;
  host: string | null;
  deployed_at: string | null;
  updating: boolean;
  pages: LiveSitePage[];
  /** Members only: */
  enabled?: boolean;
  unavailable_reason?: string | null;
  last_error?: string | null;
  charged?: boolean;
  deploys?: LiveSiteDeploy[];
}

const path = (projectId: string) => `/api/v1/projects/${projectId}/live-site`;

export const liveSiteService = {
  async get(projectId: string): Promise<LiveSite> {
    return (await axiosInstance.get(path(projectId))).data;
  },
  async redeploy(projectId: string): Promise<LiveSite> {
    return (await axiosInstance.post(`${path(projectId)}/deploy`)).data;
  },
};
